import { Message } from 'element-ui';
import tokenStorage, { getCookie } from '@/helpers/tokenStorage';
import {
  createCrudActions,
  createCrudActionTypes,
  createCrudMutation,
  createCrudState
} from 'vuex-module-generator';

import { fetchAccount, updateAccount } from './api';
import i18n from '../../i18n';
import errorResolver from '../../helpers/errorResolver';

export const accountTypes = {
  ...createCrudActionTypes('ACCOUNT')
};

export const AccountState = () => ({
  active: createCrudState().active,
  updating: createCrudState().updating
});

export const mutations = {
  ...createCrudMutation(accountTypes)
};

export const actions = createCrudActions(accountTypes);

// sort projects by last visit start date
const sortProjects = (data) => {
  const sortedProjects = data.projects.sort((a, b) => new Date(b.last_visit.started_at) - new Date(a.last_visit.started_at));

  return { ...data, projects: sortedProjects };
};

export default {
  state: AccountState,
  mutations,
  actions: {
    async fetchAccount({ commit }) {
      commit(actions.show.request());

      try {
        const token = tokenStorage.get().access_token;
        const cachedAccount = JSON.parse(localStorage.getItem('account'));
        const cachedAccountToken = localStorage.getItem('account_token');
        const cacheCounter = getCookie('cache_counter');
        let account = null;

        // Use cached account info from local storage
        if (cacheCounter && cachedAccount && cachedAccountToken === token) {
          account = cachedAccount;
        } else {
          const res = await fetchAccount();

          account = res.data.data;
        }

        i18n.locale = account.preferred_language;

        if (account.developer) {
          window.usetifulTags = { userId: `${account.id}`, language: account.preferred_language, role: 'developer' };
        } else if (account.savant) {
          window.usetifulTags = { userId: `${account.id}`, language: account.preferred_language, role: 'savant' };
        } else {
          window.usetifulTags = { userId: `${account.id}`, language: account.preferred_language, role: '' };
        }

        document.querySelector('html').setAttribute('lang', i18n.locale);

        // Cache account info and token
        localStorage.setItem('account', JSON.stringify(account));
        localStorage.setItem('account_token', token);

        // set cache counter in cookie
        let expire = 180 * 60; // 3 hours
        const diffinseconds = new Date().getTimezoneOffset() * 60;
        expire += diffinseconds > 0 ? diffinseconds : -diffinseconds;
        document.cookie = `cache_counter=1; path=/; max-age=${expire}; samesite=lax; secure`;

        commit(actions.show.success({ data: sortProjects(account) }));

        return Promise.resolve({ data: sortProjects(account) });
      } catch (error) {
        commit(actions.show.failure(error));

        return Promise.reject(error);
      }
    },
    async updateAccount({ commit, dispatch, state }, { data }) {
      commit(actions.update.request());
      try {
        const cachedAccount = localStorage.getItem('account');

        if (cachedAccount) {
          const parseCacheData = JSON.parse(cachedAccount);

          parseCacheData.preferred_language = data.user.preferred_language;
          localStorage.setItem('account', JSON.stringify(parseCacheData));
        }

        const res = await updateAccount(data);

        await dispatch('fetchAccount');
        commit(actions.update.success({ data: sortProjects(state.active.data) }));

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.update.failure(error));
        const { message } = errorResolver(error);
        Message({
          type: 'error',
          title: 'Error',
          message
        });

        return Promise.reject(error);
      }
    }
  }
};
